import { Link } from 'react-router-dom';
import { PageTransition, StaggeredReveal } from '../components/common/PageTransition';

const About = () => {
  const team = [
    {
      name: 'Larry Mecha',
      role: 'Founder & CEO',
      bio: 'Visionary leader with 15+ years in Agri-Tech. Passionate about empowering smallholder farmers.',
      imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    {
      name: 'Mark Kamau',
      role: 'Head of Technology',
      bio: 'Expert in AI and Data Systems. Leads the development of our predictive analytics engine.',
      imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    {
      name: 'Charlyne Wanjiku',
      role: 'Agricultural Expert',
      bio: 'Dedicated to farmer relations and extension services, bridging the gap between tech and soil.',
      imageUrl: 'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    {
      name: 'David Omondi',
      role: 'Head of Operations',
      bio: 'Supply chain veteran ensuring seamless logistics between farmers, vendors, and markets.',
      imageUrl: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    {
      name: 'Grace Adhiambo',
      role: 'Vendor Partnerships',
      bio: 'Curating the best tools and inputs for our marketplace ecosystem.',
      imageUrl: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    {
      name: 'James Mwangi',
      role: 'Market Analyst',
      bio: 'Economist specializing in commodity trading and regional market trends.',
      imageUrl: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
  ];

  return (
    <PageTransition>
      {/* Hero section */}
      <StaggeredReveal delay={0.1}>
        <div className="relative bg-green-800">
          <div className="absolute inset-0">
            <img
              className="object-cover w-full h-full"
              src="https://images.unsplash.com/photo-1523741543316-beb7fc7023d8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
              alt="Farmers working in the field"
            />
            <div className="absolute inset-0 bg-green-800 mix-blend-multiply" />
          </div>
          <div className="relative px-4 py-24 mx-auto max-w-7xl sm:py-32 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
              About Us
            </h1>
            <p className="mt-6 max-w-3xl text-xl text-green-100">
              We're on a mission to revolutionize agriculture in Kenya by connecting farmers with technology and markets.
            </p>
          </div>
        </div>
      </StaggeredReveal>

      {/* Mission section */}
      <StaggeredReveal delay={0.3}>
        <div className="overflow-hidden py-16 bg-white dark:bg-gray-900 lg:py-24">
          <div className="relative px-4 mx-auto max-w-xl sm:px-6 lg:px-8 lg:max-w-7xl">
            <div className="relative">
              <h2 className="text-3xl font-extrabold tracking-tight leading-8 text-center text-gray-900 dark:text-white sm:text-4xl">
                Empowering the Agricultural Ecosystem
              </h2>
              <p className="mx-auto mt-4 max-w-3xl text-xl text-center text-gray-500 dark:text-gray-300">
                Farmers Hub is more than just a dashboard; it's a comprehensive ecosystem designed to bridge the gap between smallholder farmers, agile vendors, and large-scale market players.
              </p>
              <div className="mt-8 max-w-3xl mx-auto text-lg text-gray-500 dark:text-gray-300">
                <p>By leveraging real-time data, AI-driven insights, and a seamless marketplace, we ensure that:</p>
                <ul className="mt-4 list-disc list-inside space-y-2 pl-4">
                  <li><strong>Farmers</strong> maximize yields and profits through precision agriculture.</li>
                  <li><strong>Vendors</strong> reach a wider customer base for inputs and equipment.</li>
                  <li><strong>Policymakers</strong> make informed decisions based on accurate regional data.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </StaggeredReveal>

      {/* Team section */}
      <StaggeredReveal delay={0.5}>
        <div className="py-16 bg-gray-50 dark:bg-gray-800 sm:py-24">
          <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="lg:text-center">
              <h2 className="text-base font-semibold tracking-wide text-green-600 dark:text-green-400 uppercase">Our Team</h2>
              <p className="mt-2 text-3xl font-extrabold tracking-tight leading-8 text-gray-900 dark:text-white sm:text-4xl">
                Meet the people behind Farmers HUB
              </p>
            </div>

            <div className="mt-10">
              <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10">
                {team.map((person, index) => (
                  <StaggeredReveal key={person.name} delay={0.6 + index * 0.1}>
                    <div className="relative">
                      <div className="relative mx-auto w-64 h-64">
                        <img
                          className="object-cover w-64 h-64 rounded-full"
                          src={person.imageUrl}
                          alt={person.name}
                        />
                      </div>
                      <div className="mt-4 text-center">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">{person.name}</h3>
                        <p className="text-sm text-green-600 dark:text-green-400 font-medium">{person.role}</p>
                        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">{person.bio}</p>
                      </div>
                    </div>
                  </StaggeredReveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </StaggeredReveal>

      {/* Values section */}
      <StaggeredReveal delay={0.8}>
        <div className="overflow-hidden py-16 bg-white dark:bg-gray-900 lg:py-24">
          <div className="relative px-4 mx-auto max-w-xl sm:px-6 lg:px-8 lg:max-w-7xl">
            <div className="relative">
              <h2 className="text-3xl font-extrabold tracking-tight leading-8 text-center text-gray-900 dark:text-white sm:text-4xl">
                Our Values
              </h2>
              <div className="mt-10">
                <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                  <div className="relative">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">Innovation</h3>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-300">
                      We constantly explore new technologies and solutions to improve farming practices and market access.
                    </p>
                  </div>
                  <div className="relative">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">Sustainability</h3>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-300">
                      We promote sustainable farming practices that benefit both farmers and the environment.
                    </p>
                  </div>
                  <div className="relative">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">Community</h3>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-300">
                      We foster a strong community of farmers, buyers, and agricultural experts.
                    </p>
                  </div>
                  <div className="relative">
                    <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">Transparency</h3>
                    <p className="mt-2 text-base text-gray-500 dark:text-gray-300">
                      We believe in open communication and transparent market information.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </StaggeredReveal>

      {/* CTA section */}
      <StaggeredReveal delay={1.0}>
        <div className="bg-green-700 dark:bg-green-900 transition-colors duration-200">
          <div className="px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
            <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              <span className="block">Ready to join our mission?</span>
              <span className="block text-green-200">Start your journey with us today.</span>
            </h2>
            <div className="flex mt-8 lg:mt-0 lg:flex-shrink-0">
              <div className="inline-flex rounded-md shadow">
                <Link
                  to="/register"
                  className="inline-flex justify-center items-center px-5 py-3 text-base font-medium text-green-600 bg-white rounded-md border border-transparent hover:bg-green-50"
                >
                  Get started
                </Link>
              </div>
            </div>
          </div>
        </div>
      </StaggeredReveal>
    </PageTransition>
  );
};

export default About; 